{
  "clear": "Wyczyść",
  "invalid": "(nieprawidłowy)",
  "loading": "Trwa ładowanie...",
  "noResults": "Brak wyników",
  "valid": "(ważny)"
}
